import AxiosInstance from 'utils/AxiosInstance'
import {
  FETCH_SLACK_CHANNELS_REQUEST,
  FETCH_SLACK_CHANNELS_SUCCESS,
  FETCH_SLACK_CHANNELS_FAILURE,
  CREATE_SLACK_CHANNEL_REQUEST,
  CREATE_SLACK_CHANNEL_SUCCESS,
  CREATE_SLACK_CHANNEL_FAILURE,
  UPDATE_SLACK_CHANNEL_REQUEST,
  UPDATE_SLACK_CHANNEL_SUCCESS,
  UPDATE_SLACK_CHANNEL_FAILURE,
  DELETE_SLACK_CHANNEL_REQUEST,
  DELETE_SLACK_CHANNEL_SUCCESS,
  DELETE_SLACK_CHANNEL_FAILURE,
  SET_SLACK_CHANNEL_MODAL,
  CLEAR_SLACK_CHANNEL_ERRORS,
} from './constants'

// Fetch all slack channels
export const fetchSlackChannels = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_SLACK_CHANNELS_REQUEST })

    AxiosInstance.get('/slack-channels')
      .then((response) => {
        dispatch({
          type: FETCH_SLACK_CHANNELS_SUCCESS,
          payload: response,
        })
      })
      .catch((error) => {
        dispatch({
          type: FETCH_SLACK_CHANNELS_FAILURE,
          payload:
            error.response?.data?.message || 'Failed to fetch slack channels',
        })
      })
  }
}

// Create slack channel
export const createSlackChannel = (channelData) => {
  return (dispatch) => {
    dispatch({ type: CREATE_SLACK_CHANNEL_REQUEST })

    AxiosInstance.post('/slack-channels', channelData)
      .then((response) => {
        dispatch({
          type: CREATE_SLACK_CHANNEL_SUCCESS,
          payload: response,
        })
        // Refresh the list after successful creation
        dispatch(fetchSlackChannels())
        dispatch(setSlackChannelModal({ show: false }))
      })
      .catch((error) => {
        dispatch({
          type: CREATE_SLACK_CHANNEL_FAILURE,
          payload:
            error.response?.data?.message || 'Failed to create slack channel',
        })
      })
  }
}

// Update slack channel
export const updateSlackChannel = (channelId, channelData) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_SLACK_CHANNEL_REQUEST })

    AxiosInstance.put(`/slack-channels/${channelId}`, channelData)
      .then((response) => {
        dispatch({
          type: UPDATE_SLACK_CHANNEL_SUCCESS,
          payload: response,
        })
        // Refresh the list after successful update
        dispatch(fetchSlackChannels())
        dispatch(setSlackChannelModal({ show: false }))
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_SLACK_CHANNEL_FAILURE,
          payload:
            error.response?.data?.message || 'Failed to update slack channel',
        })
      })
  }
}

// Delete slack channel
export const deleteSlackChannel = (channelId) => {
  return (dispatch) => {
    dispatch({ type: DELETE_SLACK_CHANNEL_REQUEST })

    AxiosInstance.delete(`/slack-channels/${channelId}`)
      .then((response) => {
        dispatch({
          type: DELETE_SLACK_CHANNEL_SUCCESS,
          payload: response,
        })
        // Refresh the list after successful deletion
        dispatch(fetchSlackChannels())
      })
      .catch((error) => {
        dispatch({
          type: DELETE_SLACK_CHANNEL_FAILURE,
          payload:
            error.response?.data?.message || 'Failed to delete slack channel',
        })
      })
  }
}

// Set modal state
export const setSlackChannelModal = (modalData) => ({
  type: SET_SLACK_CHANNEL_MODAL,
  payload: modalData,
})

// Clear errors
export const clearSlackChannelErrors = () => ({
  type: CLEAR_SLACK_CHANNEL_ERRORS,
})
